import classNames from "classnames/dedupe";
import { Button, Flex, Image, Text, Icon } from "@simplybusiness/mobius";
import { lock } from "@simplybusiness/icons";
import { CancelAnytime } from "../../CancelAnytime";

export const CallToAction = ({
  enableCheckoutFormSubmission,
  isFormSubmitting,
  fireCheckoutButtonClickedEvent,
  onCallToActionClick,
  buttonText,
  poweredByStripeLogo,
  eventTrackerCallback,
  combinedPaymentPage,
  eligibleForCancelAnytime,
}: CallToActionProps) => {
  return (
    <div
      className={classNames("mobius-payment-summary__form-actions-box", {
        "combined-payment-page-sticky": !enableCheckoutFormSubmission,
      })}
    >
      <Flex
        data-testid="payment-cta-container"
        className={classNames({
          "mobius-payment-cta-container-align-left": combinedPaymentPage,
          "mobius-payment-summary__cart-summary":
            !combinedPaymentPage && eligibleForCancelAnytime,
        })}
      >
        {(combinedPaymentPage || eligibleForCancelAnytime) && (
          <CancelAnytime
            eventTrackerCallback={eventTrackerCallback}
            className={classNames({
              "mobius-cancel-anytime__cart-summary":
                !combinedPaymentPage && eligibleForCancelAnytime,
            })}
          />
        )}
        {enableCheckoutFormSubmission ? (
          <Button
            className="mobius-payment-summary__checkout-button"
            type="submit"
            size="md"
            isLoading={isFormSubmitting}
            isDisabled={isFormSubmitting}
            data-testid="submit-btn"
            onClick={fireCheckoutButtonClickedEvent}
          >
            Checkout
          </Button>
        ) : (
          <Flex flexDirection="column">
            <Button
              className="mobius-payment-summary__checkout-button combined-payment-page-sticky"
              size="md"
              data-testid="open-payment-drawer-btn"
              onClick={() => onCallToActionClick(true)}
            >
              {buttonText}
            </Button>
            <Flex
              flexDirection="row"
              alignItems="center"
              justifyContent="center"
            >
              <Icon
                icon={lock}
                className="mobius-call-to-action_secure-checkout-icon"
              />
              <Text className="mobius-call-to-action_secure-checkout-text">
                Secure Checkout{" "}
              </Text>
              <Image
                className="powered-by-stripe-logo"
                src={poweredByStripeLogo}
                alt="Powered by Stripe"
              />
            </Flex>
          </Flex>
        )}
      </Flex>
    </div>
  );
};

export interface CallToActionProps {
  enableCheckoutFormSubmission: boolean;
  isFormSubmitting: boolean;
  fireCheckoutButtonClickedEvent: () => void;
  onCallToActionClick: (drawerOpen: boolean) => void;
  buttonText: string;
  poweredByStripeLogo: string;
  eventTrackerCallback: () => void;
  combinedPaymentPage: boolean;
  eligibleForCancelAnytime: boolean;
}
